import { render, staticRenderFns } from "./Riders.vue?vue&type=template&id=311db2fa&scoped=true&"
import script from "./Riders.vue?vue&type=script&lang=js&"
export * from "./Riders.vue?vue&type=script&lang=js&"
import style0 from "./Riders.vue?vue&type=style&index=0&id=311db2fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311db2fa",
  null
  
)

export default component.exports